import { useState, useEffect } from 'react';
import '../../../scss/workoffice.scss';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CheckInWorkOffice, CheckOutWorkOffice, GetWorkOffice } from '../../../reduxToolkit/Department/DepartmentApi';
import { toast } from 'react-toastify';
import { GetUserFullInformation } from '../../../reduxToolkit/Commons/CommonsApi';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const WorkOfficeFunctionality = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [checkIn, setCheckIn] = useState(null);
    const [checkOut, setCheckOut] = useState(null);
    const { getWorkOffice } = useSelector((state) => state.DepartmentSectionSlice);
    const { idSet } = useSelector((state) => state.CommonsSlice);
    const { getUserFullInformation } = useSelector((state) => state.CommonsSlice);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    // Function to handle check in action
    const checkInFn = () => {
        if (latitude && longitude) {
            const data = {
                accessMethodIdIn: 9,
                checkInLatitude: latitude,
                checkInLongitude: longitude,
            };
            dispatch(CheckInWorkOffice(data)).then(
                ({
                    payload: {
                        data: { data, success },
                    },
                }) => {
                    if (success === true) {
                        setCheckIn(data?.data?.checkIn);
                        toast.success(t('check_in_success'));
                    }
                },
            );
        } else {
            toast.info(t('we_need_the_access_to_check_your_check_in'));
        }
    };

    // Function to handle checkout action
    const checkOutFn = () => {
        if (latitude && longitude) {
            const data = {
                accessMethodIdOut: 9,
                checkOutLatitude: latitude,
                checkOutLongitude: longitude,
            };
            dispatch(CheckOutWorkOffice(data)).then(
                ({
                    payload: {
                        data: { data, success },
                    },
                }) => {
                    if (success === true) {
                        setCheckOut(data?.data?.checkOut);
                        toast.success(t('check_out_success'));
                    }
                },
            );
        } else {
            toast.info(t('we_need_the_access_to_check_your_checkout'));
        }
    };
    // useEffect to fetch the home office data when checkin or checkout changes
    useEffect(() => {
        dispatch(GetWorkOffice()).then(({ payload: { data } }) => {});
    }, [checkIn, checkOut]);
    // useEffect to fetch the user photo based on the user ID
    useEffect(() => {
        const fetchGetPhotoFromUser = async () => {
            await dispatch(GetUserFullInformation(idSet));
        };
        if (idSet) {
            fetchGetPhotoFromUser();
        }
    }, [idSet]);

    // useEffect to watch the geolocation of the user and update latitude and longitude
    useEffect(() => {
        if (navigator.geolocation) {
            const geoWatch = navigator.geolocation.watchPosition((position) => {
                const { latitude, longitude } = position.coords;
                setLatitude(latitude);
                setLongitude(longitude);
            });
            return () => {
                navigator.geolocation.clearWatch(geoWatch);
            };
        } else {
            toast.info(t('geolocation_not_supported'));
        }
    }, []);
    // useEffect to check for geolocation permissions
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.permissions.query({ name: 'geolocation' }).then((result) => {
                if (result.state === 'prompt') {
                    toast.success(t('please_give_access_to_your_localization'));
                } else if (result.state === 'denied') {
                 // Display the message only if either check-in or check-out is null
                 if (getWorkOffice.checkIn === null || getWorkOffice.checkOut === null) {
                    toast.success(t('we_need_the_access_to_check_your_check_in'));
                }
                }
            });
        } else {
            toast.info(t('geolocation_not_supported'));
        }
    }, []);

    return {
        checkIn,
        checkOut,
        checkInFn,
        checkOutFn,
        getWorkOffice,
        getUserFullInformation,
        t,
    };
};
